import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineEditorComponent } from './inline-editor.component';
import { MatDatepickerModule } from "@angular/material/datepicker";

@NgModule({
  declarations: [
    InlineEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule
],
  exports: [
    InlineEditorComponent
  ]
})
export class InlineEditorModule { }
